export default __webpack_public_path__ + "static/media/me.4e2454b3.webp";